import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { certboxActions } from '../../../../store/actions';
import CertRecvBox from "./CertRecvBox";

const CertboxReceiver = props => {
  const [ state, setState ] = useState({});
  const [ receiverList, setReceiverList] = useState([
    // {ewalletId: 'test', name: '국세청'}
  ]);

  useEffect(() => {
    props.getReceiverList(receiverList);
  }, [receiverList]);

  // 전자지갑 주소 사용자 추가시
  useEffect(() => {
    if (!props.receiver) return;

    let list = [];

    props.receiver.map((target) => {
      list.push({
        ewalletId: target.ewalletId,
        name: target.name
      })
    })

    setReceiverList([
      ...receiverList,
      ...list
    ])
  }, [props.receiver]);

  // 줄제거시
  const deleteRow = (rId) => {
    const setList = receiverList?.filter(receiver => receiver.ewalletId !== rId);

    setReceiverList(setList);
  }

  const openAddrBox = (boxType) => {
    const popInfo = {
      type: true,
      subject: ''
    };

    popInfo.subject = boxType;

    props.openReceiverBox(popInfo);
  }

  return (
    <>
      <div className="detail-table-box">
       <div className="detail-title">수신자</div>

        <div className="detail-table-scroll">
          <div className="inner">
            <div className="scroll">
              <div className="row">
                <ul className="flex-col">
                  {
                    receiverList?.map((receiver, index) => (
                      <li key={receiver.ewalletId + index} className="flex-sb w-full receiver">
                        <button className="btn btn-del" onClick={() => deleteRow(receiver.ewalletId)}>-</button>
                        <div className="flex-col w-full">
                          <span className="title">{receiver.name}</span>
                        </div>
                      </li>
                    ))
                  }
                  <li key="search" className="flex-sb w-full receiver">
                    <div className="flex-col w-full">
                      <span className="title">전자지갑주소 검색</span>
                    </div>
                    <button className="btn btn-add" onClick={() => openAddrBox('Search')}>&gt;</button>
                  </li>
                  <li key="recent" className="flex-sb w-full receiver">
                    <div className="flex-col w-full">
                      <span className="title">최근 보낸 주소</span>
                    </div>
                    <button className="btn btn-add" onClick={() => openAddrBox('Recent')}>&gt;</button>
                  </li>
                  <li key="paste" className="flex-sb w-full receiver">
                    <div className="flex-col w-full">
                      <span className="title">지갑주소 붙여넣기</span>
                    </div>
                    <button className="btn btn-add" onClick={() => openAddrBox('Paste')}>&gt;</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CertRecvBox/>
    </>
  )
}
const mapStateToProps = state => {
  return {
    receiver: state?.certbox?.receiver
  }
}

const actionCreators = {
  openReceiverBox: certboxActions.openReceiverBox,
}

export default connect(
  mapStateToProps,
  actionCreators
)(CertboxReceiver)